import React from "react";
import {
  Button,
  FormGroup,
  FormInput,
  Row,
  Col,
  Form,
  FormFeedback,
  FormTextarea,
  FormCheckbox,
} from "shards-react";
import { useFormik } from "formik";
import { SelectAgency, SelectagencyType } from "shared/components";
import { ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import baseUrl from "config/baseUrl";

const axios = require("axios").default;

const StyledContent = styled.div`
  height: calc(100vh - 290px);
  overflow-y: scroll;
  padding-bottom: 20px;
`;

const StyledForm = styled(Form)`
  position: relative;
`;
const StyledFooter = styled.div`
  width: 100%;
  bottom: 0;
  background-color: #fff;
`;

const FormRegister = (props) => {
  const { t, i18n } = useTranslation();
  const { onChangeStatus } = props;
  const showNotify = (message, type) => {
    switch (type) {
      case "success":
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "error":
        toast.error(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "warn":
        toast.warn(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "info":
        toast.info(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      default:
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
    }
  };
  const validate = (values) => {
    const errors = {};
    if (!values.username) {
      errors.username = t("common:logIn.PleaseEnterUsername");
    }
    if (!values.password) {
      errors.password = t("common:logIn.PleaseEnterPassword");
    }
    if (!values.confirmpassword) {
      errors.confirmpassword = t("common:logIn.PleaseEnterPassword");
    } else if (values.password !== values.confirmpassword) {
      errors.confirmpassword = t("common:resetPassword.PasswordsMatch");
    }
    if (!values.firstName) {
      errors.firstName = t("common:logIn.PleaseEnterName");
    }
    if (!values.lastName) {
      errors.lastName = t("common:logIn.PleaseEnterSurname");
    }
    if (!values.email) {
      errors.email = t("common:logIn.PleaseEnterEmail");
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
      errors.email = t("common:logIn.InvalidEmailAddress");
    }
    if (!values.phone) {
      errors.phone = t("common:logIn.PleaseEnterTel");
    } else if (values.phone.length < 10) {
      errors.phone = t("common:logIn.PleaseEnterValidNumber");
    }
    if (!values.agencyId) {
      errors.agencyId = t("common:logIn.PleaseEnterAgencyName");
    } else if (values.agencyId === "0") {
      errors.agencyId = t("common:logIn.PleaseEnterAgencyName");
    }

    if (values.agencyId === "32" && !values.agencyName) {
      errors.agencyName = t("common:logIn.PleaseEnterAgencyName");
    }

    // if (!values.positionName) {
    //   errors.positionName = "กรุณาระบุตำแหน่ง";
    // }
    if (!values.agencyTypeId) {
      errors.agencyTypeId = t("common:logIn.PleaseEnterTypeOfAgency");
    } else if (values.agencyTypeId === "0") {
      errors.agencyTypeId = t("common:logIn.PleaseEnterTypeOfAgency");
    }
    // if (!values.purposeAccessingSystem) {
    //   errors.purposeAccessingSystem =
    //     "กรุณารเลือกจุดประสงค์ในการเข้าใช้งานระบบ";
    // }

    if (!values.checkPolicy && values.checkPolicy !== "true") {
      errors.checkPolicy = t("common:logIn.PleasecheckPolicy");
    }

    return errors;
  };
  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
      confirmpassword: "",
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      agencyTypeId: "0",
      agencyId: "",
      positionName: "",
      agencyType: "",
      agencyName: "",
      purposeAccessingSystem: "",
      checkPolicy: "",
    },
    validate,
    onSubmit: (values) => {
      delete values.confirmpassword;
      delete values.checkPolicy;
      axios
        .post(`${baseUrl}/v1/user/create`, values)
        .then(function(response) {
          onChangeStatus(1);
          showNotify(t("common:logIn.NotiCreateUser"));
        })
        .catch(function(error) {
          if (error.response.data.message) {
            if (error.response.data.data.length > 0) {
              error.response.data.data.map((item) => {
                return showNotify(`${item.value} - ${item.msg}`, "error");
              });
            } else {
              showNotify(error.response.data.message, "error");
            }
          } else {
            showNotify(error.message, "error");
          }
        });
    },
  });

  return (
    <div>
      <ToastContainer />
      <h6 className="bold text-center">{t("common:logIn.SignUp")}</h6>
      <h6 className="bold ">{t("common:logIn.LoginInformation")}</h6>
      <StyledForm onSubmit={formik.handleSubmit}>
        <StyledContent>
          <Row>
            <Col md="4">
              <FormGroup>
                <label htmlFor="username">
                  {t("common:logIn.Username")}
                  <span className="color-red">*</span>
                </label>
                <FormInput
                  type="text"
                  name="username"
                  placeholder={t("common:logIn.Username")}
                  onChange={formik.handleChange}
                  invalid={!!formik.errors.username}
                  value={formik.values.username}
                />
                {formik.errors.username && (
                  <FormFeedback>
                    {t("common:logIn.PleaseEnterUsername")}
                  </FormFeedback>
                )}
              </FormGroup>
            </Col>
            <Col md="4">
              <FormGroup>
                <label>
                  {t("common:logIn.Password")}
                  <span className="color-red">*</span>
                </label>
                <FormInput
                  type="password"
                  name="password"
                  placeholder={t("common:logIn.Password")}
                  onChange={formik.handleChange}
                  invalid={!!formik.errors.password}
                  value={formik.values.password}
                />
                {formik.errors.password && (
                  <FormFeedback>
                    {t("common:logIn.PleaseEnterPassword")}
                  </FormFeedback>
                )}
              </FormGroup>
            </Col>
            <Col md="4">
              <FormGroup>
                <label>
                  {t("common:logIn.ConfirmPassword")}
                  <span className="color-red">*</span>
                </label>
                <FormInput
                  type="password"
                  name="confirmpassword"
                  placeholder={t("common:logIn.ConfirmPassword")}
                  onChange={formik.handleChange}
                  invalid={!!formik.errors.confirmpassword}
                  value={formik.values.confirmpassword}
                />
                {formik.errors.confirmpassword && (
                  <FormFeedback>
                    {t("common:logIn.PleaseEnterConfirmPassword")}
                  </FormFeedback>
                )}
              </FormGroup>
            </Col>
          </Row>
          <h6 className="bold ">{t("common:logIn.PersonalInformation")}</h6>
          <Row>
            <Col md="4">
              <FormGroup>
                <label>
                  {t("common:logIn.Name")}
                  <span className="color-red">*</span>
                </label>
                <FormInput
                  type="text"
                  placeholder={t("common:logIn.Name")}
                  name="firstName"
                  onChange={formik.handleChange}
                  invalid={!!formik.errors.firstName}
                  value={formik.values.firstName}
                />
                {formik.errors.firstName && (
                  <FormFeedback>
                    {t("common:logIn.PleaseEnterName")}
                  </FormFeedback>
                )}
              </FormGroup>
            </Col>
            <Col md="4">
              <FormGroup>
                <label>
                  {t("common:logIn.Surname")}
                  <span className="color-red">*</span>
                </label>
                <FormInput
                  type="text"
                  placeholder={t("common:logIn.Surname")}
                  name="lastName"
                  onChange={formik.handleChange}
                  invalid={!!formik.errors.lastName}
                  value={formik.values.lastName}
                />
                {formik.errors.lastName && (
                  <FormFeedback>
                    {t("common:logIn.PleaseEnterSurname")}
                  </FormFeedback>
                )}
              </FormGroup>
            </Col>
            <Col md="4">
              <FormGroup>
                <label>
                  {t("common:logIn.Tel")}
                  <span className="color-red">*</span>
                </label>
                <FormInput
                  type="tel"
                  name="phone"
                  placeholder={t("common:logIn.Tel")}
                  onChange={formik.handleChange}
                  invalid={!!formik.errors.phone}
                  value={formik.values.phone}
                />
                {formik.errors.phone && (
                  <FormFeedback>
                    {t("common:logIn.PleaseEnterTel")}
                  </FormFeedback>
                )}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="4">
              <FormGroup>
                <label>
                  {t("common:logIn.Email")}
                  <span className="color-red">*</span>
                </label>
                <FormInput
                  type="email"
                  name="email"
                  placeholder={t("common:logIn.Email")}
                  onChange={formik.handleChange}
                  invalid={!!formik.errors.email}
                  value={formik.values.email}
                />
                {formik.errors.email && (
                  <FormFeedback>
                    {t("common:logIn.PleaseEnterEmail")}
                  </FormFeedback>
                )}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="4">
              <FormGroup>
                <label>
                  {t("common:logIn.TypeOfAgency")}
                  <span className="color-red">*</span>
                </label>
                <SelectagencyType
                  placeholder={t("common:logIn.Select")}
                  name="agencyTypeId"
                  onChange={(e) => {
                    const id = e.nativeEvent.target.selectedIndex;
                    if(id !== "1" && id !== "0" && id !== 1 && id !== 0){
                      formik.values.agencyId = "32";
                    }
                    formik.values.agencyName = "";
                    formik.values.agencyType = e.nativeEvent.target[id].text;
                    formik.handleChange(e);
                  }}
                  value={formik.values.agencyTypeId}
                  invalid={!!formik.errors.agencyTypeId}
                  onBlur={formik.handleBlur}
                />
                {formik.errors.agencyTypeId && (
                  <FormFeedback>
                    {t("common:logIn.PleaseEnterTypeOfAgency")}
                  </FormFeedback>
                )}
              </FormGroup>
            </Col>
            <Col md="4">
              <FormGroup>
                <label>
                  {t("common:logIn.AgencyName")}
                  <span className="color-red">*</span>
                </label>
                <SelectAgency
                  placeholder={t("common:logIn.Select")}
                  name="agencyId"
                  onChange={(e) => {
                    const id = e.nativeEvent.target.selectedIndex;
                    if (e.target.value === "32") {
                      formik.values.agencyName = "";
                    } else {
                      formik.values.agencyName = e.nativeEvent.target[id].text;
                    }
                    formik.handleChange(e);
                  }}
                  value={formik.values.agencyId}
                  invalid={!!formik.errors.agencyId}
                  typeId={formik.values.agencyTypeId}
                  onBlur={formik.handleBlur}
                  disabled={
                    formik.values.agencyTypeId !== "0" &&
                    (formik.values.agencyTypeId !== 1 &&
                    formik.values.agencyTypeId !== "1")
                  }
                />
                {/* <FormInput
                type="text"
                placeholder="ชื่อหน่วยงาน"
                name="agencyName"
                onChange={formik.handleChange}
                invalid={!!formik.errors.agencyName}
                value={formik.values.agencyName}
              /> */}
                {formik.errors.agencyId && (
                  <FormFeedback>
                    {t("common:logIn.PleaseEnterAgencyName")}
                  </FormFeedback>
                )}
              </FormGroup>
            </Col>
            {formik.values.agencyId === "32" && (
              <Col md="4">
                <FormGroup>
                  <label>{t("common:logIn.AgencyName")}</label>
                  <FormInput
                    type="text"
                    placeholder={t("common:logIn.PleaseSpecify")}
                    onChange={formik.handleChange}
                    name="agencyName"
                    invalid={!!formik.errors.agencyName}
                    value={formik.values.agencyName}
                  />
                  {formik.errors.agencyName && (
                    <FormFeedback>
                      {t("common:logIn.PleaseEnterAgencyName")}
                    </FormFeedback>
                  )}
                </FormGroup>
              </Col>
            )}
            <Col md="4">
              <FormGroup>
                <label>{t("common:logIn.PositionProfession")}</label>
                <FormInput
                  type="text"
                  placeholder={t("common:logIn.PositionProfession")}
                  onChange={formik.handleChange}
                  name="positionName"
                  invalid={!!formik.errors.positionName}
                  value={formik.values.positionName}
                />
                {/* {formik.errors.positionName && (
                  <FormFeedback>{formik.errors.positionName}</FormFeedback>
                )} */}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <FormGroup>
                <label>{t("common:logIn.PurposeSystem")}</label>
                <FormTextarea
                  name="purposeAccessingSystem"
                  onChange={formik.handleChange}
                  value={formik.values.purposeAccessingSystem}
                  // invalid={!!formik.errors.purposeAccessingSystem}
                  placeholder={t("common:logIn.PurposeSystem")}
                />

                {/* {formik.errors.purposeAccessingSystem && (
                <FormFeedback>
                  {formik.errors.purposeAccessingSystem}
                </FormFeedback>
              )} */}
              </FormGroup>
            </Col>
            <Col md="12">
              <FormGroup>
                <FormCheckbox
                  name="checkPolicy"
                  checked={formik.values.checkPolicy === "true"}
                  onChange={() =>
                    formik.setFieldValue(
                      "checkPolicy",
                      formik.values.checkPolicy === "true" ? "" : "true"
                    )
                  }
                  invalid={!!formik.errors.checkPolicy}
                >
                  {t("common:logIn.CheckPolicy")}{" "}
                  <a href="/policy" target="_blank">
                    {t("common:logIn.ReadCheckPolicy")}
                  </a>
                </FormCheckbox>
              </FormGroup>
            </Col>
          </Row>
        </StyledContent>
        <StyledFooter>
          <hr />
          <Row>
            <Col md="4"></Col>
            <Col md="4">
              <Button
                className="btn btn-white w-100 mb-3"
                onClick={() => onChangeStatus(1)}
              >
                {`${t("common:logIn.Back")}`}
              </Button>
            </Col>
            <Col md="4">
              <Button type="submit" className="btn btn-success w-100 mb-3">
                {t("common:logIn.Register")}
              </Button>
            </Col>
          </Row>
        </StyledFooter>
      </StyledForm>
    </div>
  );
};

export default FormRegister;
